export default "__VITE_ASSET__BuAbJV03__"